import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';
import { colors } from 'z-react-components';

import FullWidthRow from '../FullWidthRow';
import { juniorHighSchoolSubjects, highSchoolSubjects } from '../../constants/HighSchoolSubjects';

export const styles = {
    highSectionStyle: {
        paddingTop: 15,
        paddingBottom: 25,
        margin: '0 auto'
    },
    middleSectionStyle: {
        paddingTop: 15,
        paddingBottom: 25,
        margin: '0px auto',
        backgroundColor: colors.white
    },
    rowStyle: {
        background: colors.grey100
    },
    subjectContainer: {
        textAlign: 'center',
        margin: '10px 0'
    },
    middleContainer: {
        textAlign: 'center',
        margin: '0 auto',
        marginTop: 30
    },
    schoolLabel: {
        textAlign: 'center',
        fontWeight: 'bold',
        textTransform: 'uppercase'
    },
    subjectBox: {
        marginTop: 30,
        height: '125px',
        padding: 0
    },
    iconStyle: {
        height: 70,
        marginBottom: 15
    },
    subjectName: {
        fontWeight: 'bold',
        textTransform: 'uppercase'
    },
    middleSubject: {
        width: 100,
        height: 100,
        display: 'inline-block',
        margin: '0 22px'
    }
};

export default class Subjects extends Component {
    renderJuniorClass() {
        return (
            <FullWidthRow maxContentWidth={1200} backgroundColor={colors.white}>
                <Row style={styles.middleSectionStyle}>
                    <Col sm={12} style={styles.subjectContainer}>
                        <h4 style={styles.schoolLabel}>{'Scuola secondaria di primo grado'}</h4>
                        {juniorHighSchoolSubjects.map((subject, i) => {
                            return (
                                <Col key={i} mdOffset={i % 5 === 0 ? 1 : 0} md={2} style={styles.subjectBox} sm={3} xs={6}>
                                    <Col sm={12}>
                                        <img alt="subject_icon" className="z-subjectIcon" src={subject.image} style={styles.iconStyle} />
                                    </Col>
                                    <div sm={12} style={styles.subjectName}>
                                        {subject.subjectName}
                                    </div>
                                </Col>
                            );
                        })}
                    </Col>
                </Row>
            </FullWidthRow>
        );
    }

    renderHighClass() {
        return (
            <FullWidthRow backgroundColor={colors.grey100} maxContentWidth={1200}>
                <Row style={styles.highSectionStyle}>
                    <Col sm={12} style={styles.subjectContainer}>
                        <h4 style={styles.schoolLabel}>{'Scuola secondaria di secondo grado'}</h4>
                        {highSchoolSubjects.map((subject, i) => {
                            return (
                                <Col key={i} mdOffset={i % 5 === 0 ? 1 : 0} md={2} style={styles.subjectBox} sm={3} xs={6}>
                                    <Col sm={12}>
                                        <img alt="subject_icon" className="z-subjectIcon" src={subject.image} style={styles.iconStyle} />
                                    </Col>
                                    <div style={styles.subjectName}>{subject.subjectName}</div>
                                </Col>
                            );
                        })}
                    </Col>
                </Row>
            </FullWidthRow>
        );
    }

    render() {
        return (
            <Row className="cv-Subjects" style={styles.rowStyle}>
                {this.renderJuniorClass()}
                {this.renderHighClass()}
            </Row>
        );
    }
}
